// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.public-header {
    position: relative;
    z-index: 100;
    width: min(1200px, calc(100% - 64px));
    min-height: 72px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    border-bottom: 1px solid var(--tp-rule);
}

.public-wordmark {
    width: fit-content;
    color: var(--tp-text);
    font-size: 21px;
    font-weight: 900;
    letter-spacing: -.07em;
    text-decoration: none;
}

.public-wordmark span {
    color: var(--tp-signal);
}

.public-desktop-nav {
    display: flex;
    align-items: stretch;
    align-self: stretch;
    gap: 30px;
}

.public-desktop-nav a {
    min-width: 44px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: var(--tp-muted);
    font-size: 14px;
    font-weight: 700;
    text-decoration: none;
}

.public-desktop-nav a:hover,
.public-desktop-nav a.active {
    color: var(--tp-text);
}

.public-desktop-nav a.active { font-weight: 850; }

.public-account {
    position: relative;
    justify-self: end;
}

.public-account-link,
.public-account-trigger {
    min-height: 44px;
    padding: 0 18px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    border: 1px solid var(--tp-cover);
    border-radius: var(--tp-radius-control);
    background: var(--tp-cover);
    color: var(--tp-cover-text);
    font-size: 13px;
    font-weight: 800;
    text-decoration: none;
    cursor: pointer;
}

.public-account-trigger svg {
    transition: transform 160ms ease;
}

.public-account-trigger[aria-expanded="true"] svg {
    transform: rotate(180deg);
}

.public-account-menu {
    position: absolute;
    top: calc(100% + 10px);
    right: 0;
    width: 180px;
    padding: 8px;
    border: 1px solid var(--tp-rule);
    border-radius: var(--tp-radius-control);
    background: var(--tp-surface);
    box-shadow: var(--tp-shadow-overlay);
}

.public-account-menu a,
.public-account-menu button {
    width: 100%;
    min-height: 44px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    gap: 8px;
    border: 0;
    border-radius: 7px;
    background: transparent;
    color: var(--tp-text);
    font-size: 13px;
    font-weight: 700;
    text-align: left;
    text-decoration: none;
    cursor: pointer;
}

.public-account-menu a:hover,
.public-account-menu button:hover {
    background: var(--tp-bg);
}

.public-content {
    min-height: calc(100dvh - 72px);
}

.public-mobile-nav {
    display: none;
}

.public-footer { margin-top:20px; background:#20221e; color:#f6f2e8; }
.public-footer-inner { width:min(1320px,calc(100% - 64px)); margin:0 auto; padding:48px 0 25px; display:grid; grid-template-columns:1fr auto; gap:45px 35px; }
.public-footer-brand { color:#fffaf0; font:800 29px Georgia,serif; letter-spacing:-.07em; text-decoration:none; }.public-footer-brand span { color:#ef674c; }
.public-footer p { margin:12px 0 0; color:#bdbcb4; font-size:13px; }
.public-footer nav { display:flex; flex-wrap:wrap; align-content:start; gap:14px 23px; }
.public-footer nav a,.public-footer-bottom a { color:#f6f2e8; font-size:12px; font-weight:750; text-decoration:none; }.public-footer a:hover { color:#ef8b75; }
.public-footer-bottom { grid-column:1/-1; padding-top:19px; display:flex; justify-content:space-between; gap:20px; border-top:1px solid #4b4d47; color:#a6a89e; font-size:11px; }
@media(max-width:767px) { .public-footer-inner { width:calc(100% - 36px); padding:37px 0 100px; grid-template-columns:1fr; gap:30px; }.public-footer nav { gap:13px 19px; }.public-footer-bottom { grid-column:auto; } }

@media (max-width: 767px) {
    .public-header {
        width: calc(100% - 36px);
        min-height: 64px;
        display: flex;
        justify-content: space-between;
    }

    .public-desktop-nav {
        display: none;
    }

    .public-account-link,
    .public-account-trigger {
        min-height: 40px;
        padding: 0 13px;
    }

    .public-mobile-nav {
        position: fixed;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 200;
        min-height: calc(64px + env(safe-area-inset-bottom));
        padding: 7px 10px env(safe-area-inset-bottom);
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        align-items: center;
        border-top: 1px solid var(--tp-rule);
        background: var(--tp-surface);
    }

    .public-mobile-nav a {
        min-width: 44px;
        min-height: 48px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 2px;
        border-radius: 8px;
        color: var(--tp-muted);
        font-size: 11px;
        font-weight: 750;
        text-decoration: none;
    }

    .public-mobile-nav a.active {
        color: var(--tp-text);
    }

    .public-mobile-nav a.create svg {
        width: 22px;
        height: 22px;
        padding: 3px;
        border-radius: 50%;
        background: var(--tp-signal);
        color: #fff;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/public/PublicShell.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;IACZ,qCAAqC;IACrC,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mCAAmC;IACnC,mBAAmB;IACnB,uCAAuC;AAC3C;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA,+BAA+B,gBAAgB,EAAE;;AAEjD;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;;IAEI,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,iCAAiC;IACjC,uCAAuC;IACvC,2BAA2B;IAC3B,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,QAAQ;IACR,YAAY;IACZ,YAAY;IACZ,gCAAgC;IAChC,uCAAuC;IACvC,6BAA6B;IAC7B,oCAAoC;AACxC;;AAEA;;IAEI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,uBAAuB;IACvB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;AACjB;;AAEA,iBAAiB,eAAe,EAAE,kBAAkB,EAAE,aAAa,EAAE;AACrE,uBAAuB,mCAAmC,EAAE,aAAa,EAAE,mBAAmB,EAAE,YAAY,EAAE,8BAA8B,EAAE,aAAa,EAAE;AAC7J,uBAAuB,aAAa,EAAE,2BAA2B,EAAE,qBAAqB,EAAE,oBAAoB,EAAE,CAAC,4BAA4B,aAAa,EAAE;AAC5J,mBAAmB,eAAe,EAAE,aAAa,EAAE,cAAc,EAAE;AACnE,qBAAqB,YAAY,EAAE,cAAc,EAAE,mBAAmB,EAAE,aAAa,EAAE;AACvF,+CAA+C,aAAa,EAAE,cAAc,EAAE,eAAe,EAAE,oBAAoB,EAAE,CAAC,yBAAyB,aAAa,EAAE;AAC9J,wBAAwB,gBAAgB,EAAE,gBAAgB,EAAE,YAAY,EAAE,6BAA6B,EAAE,QAAQ,EAAE,4BAA4B,EAAE,aAAa,EAAE,cAAc,EAAE;AAChL,0BAA0B,uBAAuB,uBAAuB,EAAE,oBAAoB,EAAE,yBAAyB,EAAE,QAAQ,EAAE,CAAC,qBAAqB,aAAa,EAAE,CAAC,wBAAwB,gBAAgB,EAAE,EAAE;;AAEvN;IACI;QACI,wBAAwB;QACxB,gBAAgB;QAChB,aAAa;QACb,8BAA8B;IAClC;;IAEA;QACI,aAAa;IACjB;;IAEA;;QAEI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,QAAQ;QACR,SAAS;QACT,OAAO;QACP,YAAY;QACZ,oDAAoD;QACpD,6CAA6C;QAC7C,aAAa;QACb,qCAAqC;QACrC,mBAAmB;QACnB,oCAAoC;QACpC,6BAA6B;IACjC;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,uBAAuB;QACvB,QAAQ;QACR,kBAAkB;QAClB,sBAAsB;QACtB,eAAe;QACf,gBAAgB;QAChB,qBAAqB;IACzB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,YAAY;QACZ,kBAAkB;QAClB,4BAA4B;QAC5B,WAAW;IACf;AACJ","sourcesContent":[".public-header {\n    position: relative;\n    z-index: 100;\n    width: min(1200px, calc(100% - 64px));\n    min-height: 72px;\n    margin: 0 auto;\n    display: grid;\n    grid-template-columns: 1fr auto 1fr;\n    align-items: center;\n    border-bottom: 1px solid var(--tp-rule);\n}\n\n.public-wordmark {\n    width: fit-content;\n    color: var(--tp-text);\n    font-size: 21px;\n    font-weight: 900;\n    letter-spacing: -.07em;\n    text-decoration: none;\n}\n\n.public-wordmark span {\n    color: var(--tp-signal);\n}\n\n.public-desktop-nav {\n    display: flex;\n    align-items: stretch;\n    align-self: stretch;\n    gap: 30px;\n}\n\n.public-desktop-nav a {\n    min-width: 44px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--tp-muted);\n    font-size: 14px;\n    font-weight: 700;\n    text-decoration: none;\n}\n\n.public-desktop-nav a:hover,\n.public-desktop-nav a.active {\n    color: var(--tp-text);\n}\n\n.public-desktop-nav a.active { font-weight: 850; }\n\n.public-account {\n    position: relative;\n    justify-self: end;\n}\n\n.public-account-link,\n.public-account-trigger {\n    min-height: 44px;\n    padding: 0 18px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    border: 1px solid var(--tp-cover);\n    border-radius: var(--tp-radius-control);\n    background: var(--tp-cover);\n    color: var(--tp-cover-text);\n    font-size: 13px;\n    font-weight: 800;\n    text-decoration: none;\n    cursor: pointer;\n}\n\n.public-account-trigger svg {\n    transition: transform 160ms ease;\n}\n\n.public-account-trigger[aria-expanded=\"true\"] svg {\n    transform: rotate(180deg);\n}\n\n.public-account-menu {\n    position: absolute;\n    top: calc(100% + 10px);\n    right: 0;\n    width: 180px;\n    padding: 8px;\n    border: 1px solid var(--tp-rule);\n    border-radius: var(--tp-radius-control);\n    background: var(--tp-surface);\n    box-shadow: var(--tp-shadow-overlay);\n}\n\n.public-account-menu a,\n.public-account-menu button {\n    width: 100%;\n    min-height: 44px;\n    padding: 0 12px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    border: 0;\n    border-radius: 7px;\n    background: transparent;\n    color: var(--tp-text);\n    font-size: 13px;\n    font-weight: 700;\n    text-align: left;\n    text-decoration: none;\n    cursor: pointer;\n}\n\n.public-account-menu a:hover,\n.public-account-menu button:hover {\n    background: var(--tp-bg);\n}\n\n.public-content {\n    min-height: calc(100dvh - 72px);\n}\n\n.public-mobile-nav {\n    display: none;\n}\n\n.public-footer { margin-top:20px; background:#20221e; color:#f6f2e8; }\n.public-footer-inner { width:min(1320px,calc(100% - 64px)); margin:0 auto; padding:48px 0 25px; display:grid; grid-template-columns:1fr auto; gap:45px 35px; }\n.public-footer-brand { color:#fffaf0; font:800 29px Georgia,serif; letter-spacing:-.07em; text-decoration:none; }.public-footer-brand span { color:#ef674c; }\n.public-footer p { margin:12px 0 0; color:#bdbcb4; font-size:13px; }\n.public-footer nav { display:flex; flex-wrap:wrap; align-content:start; gap:14px 23px; }\n.public-footer nav a,.public-footer-bottom a { color:#f6f2e8; font-size:12px; font-weight:750; text-decoration:none; }.public-footer a:hover { color:#ef8b75; }\n.public-footer-bottom { grid-column:1/-1; padding-top:19px; display:flex; justify-content:space-between; gap:20px; border-top:1px solid #4b4d47; color:#a6a89e; font-size:11px; }\n@media(max-width:767px) { .public-footer-inner { width:calc(100% - 36px); padding:37px 0 100px; grid-template-columns:1fr; gap:30px; }.public-footer nav { gap:13px 19px; }.public-footer-bottom { grid-column:auto; } }\n\n@media (max-width: 767px) {\n    .public-header {\n        width: calc(100% - 36px);\n        min-height: 64px;\n        display: flex;\n        justify-content: space-between;\n    }\n\n    .public-desktop-nav {\n        display: none;\n    }\n\n    .public-account-link,\n    .public-account-trigger {\n        min-height: 40px;\n        padding: 0 13px;\n    }\n\n    .public-mobile-nav {\n        position: fixed;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        z-index: 200;\n        min-height: calc(64px + env(safe-area-inset-bottom));\n        padding: 7px 10px env(safe-area-inset-bottom);\n        display: grid;\n        grid-template-columns: repeat(7, 1fr);\n        align-items: center;\n        border-top: 1px solid var(--tp-rule);\n        background: var(--tp-surface);\n    }\n\n    .public-mobile-nav a {\n        min-width: 44px;\n        min-height: 48px;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        gap: 2px;\n        border-radius: 8px;\n        color: var(--tp-muted);\n        font-size: 11px;\n        font-weight: 750;\n        text-decoration: none;\n    }\n\n    .public-mobile-nav a.active {\n        color: var(--tp-text);\n    }\n\n    .public-mobile-nav a.create svg {\n        width: 22px;\n        height: 22px;\n        padding: 3px;\n        border-radius: 50%;\n        background: var(--tp-signal);\n        color: #fff;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
